import type { Badge } from '../types';

interface BadgeGridProps {
    badges: Badge[];
}

const defaultBadges: Badge[] = [
    { id: 'first_scan', name: 'First Scan', icon: '♻️', earned: false },
    { id: 'streak_7', name: '7-Day Streak', icon: '🔥', earned: false },
    { id: 'scans_100', name: '100 Scans', icon: '⭐', earned: false },
    { id: 'planet_saver', name: 'Planet Saver', icon: '🌍', earned: false },
];

export default function BadgeGrid({ badges = defaultBadges }: BadgeGridProps) {
    return (
        <div className="card">
            <div className="flex items-center gap-2 mb-4">
                <span className="text-xl">🏆</span>
                <h3 className="font-semibold text-gray-900">Your Badges</h3>
            </div>
            <div className="grid grid-cols-4 gap-3">
                {badges.map((badge) => (
                    <div key={badge.id} className="flex flex-col items-center">
                        <div className={`badge ${badge.earned ? 'badge-active' : 'badge-inactive'}`}>
                            {badge.icon}
                        </div>
                        <span className={`text-xs mt-1 text-center ${badge.earned ? 'text-gray-700' : 'text-gray-400'}`}>
                            {badge.name}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
}
